<template>
  <div id="app">
    <navbar class="d-none d-sm-block" />
    <mbnavbar class="d-sm-none" />
    <keep-alive>
      <router-view :key="$route.fullPath"></router-view>
    </keep-alive>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navbar from '@/components/Navbar.vue';
import mbnavbar from '@/components/mobile/MbNavbar.vue';
import navFooter from '@/components/NavFooter2.vue';

export default {
  name: 'App',
  components: {
    navbar,
    mbnavbar,
    navFooter,
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

#app {
  text-align: center;
}
</style>
